import { en } from './en'
import { fr } from './fr'

export const typeaheads = {
  en,
  fr
}